import React, { useEffect, useState } from 'react';
import { fetchData } from '../../data-providers';
import { mapWidgetData } from '../../mappers';
import { GamingWidgetButtonContainer, GamingWidgetContainer, GamingWidgetContentContainer, GamingWidgetImageContainer, GamingWidgetWrapper, } from './styled-components';
import { GamingWidgetImage } from '../GamingWidgetImage';
import { GamingWidgetContent } from '../GamingWidgetContent';
import { GamingWidgetButton } from '../GamingWidgetButton';
export const GamingWidget = ({ dataUrl }) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        const setGamingWidgetData = async () => {
            const result = (await fetchData(dataUrl));
            if (result) {
                setData(mapWidgetData(result));
            }
        };
        setGamingWidgetData();
    }, [dataUrl]);
    if (!data) {
        return null;
    }
    const { imageUrl, content, ctaText, navigation } = data;
    return (React.createElement(GamingWidgetWrapper, null,
        React.createElement(GamingWidgetContainer, { "data-testid": "GamingWidgetContainer" },
            React.createElement(GamingWidgetImageContainer, null,
                React.createElement(GamingWidgetImage, { imageUrl: imageUrl })),
            React.createElement(GamingWidgetContentContainer, null,
                React.createElement(GamingWidgetContent, Object.assign({}, content))),
            React.createElement(GamingWidgetButtonContainer, null,
                React.createElement(GamingWidgetButton, { ctaText: ctaText, navigation: navigation })))));
};
